import Menu from "./components/Menu";
import { dB64 } from "../shared/Encriptacion";
import { Link, useNavigate, useParams } from "react-router-dom";
import { HEADERS_API } from "./NuevaGuia";
import { useState, useEffect, useSyncExternalStore } from "react";
import axios from "axios";
import { mostrarAviso} from "./components/Aviso";
import Aviso from "./components/Aviso";
import { ValidarSesion } from "../shared/Validaciones";
import { ValidarNum, ValidarNumLtr } from "../shared/Regex";
import { NMEntidadEmisora } from "../shared/Denominaciones";

export default function DetalleVehiculo(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================
    //ESTADOS DE REGISTRO
    const[entidad, setEntidad] = useState("");
    const[autorizacion, setAutorizacion] = useState("");
    const[placa, setPlaca] = useState("");
    const[descripcion, setDescripcion] = useState("");
    const[codigoEntidad, setCodigoEntidad] = useState("");
    //ESTADOS DE CONTENIDO
    const[selectEntidades, setSelectEntidades] = useState(<></>);
    //ESTADOS DE VALIDACIÓN
    const[datosCompletos, setDatosCompletos] = useState(false);
    //#endregion

    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    useEffect(()=>{
        const inicio = async () => {
            ValidarSesion();
            await obtenerListaEntidades();
            obtenerDatosVehiculo();
        }

        inicio();
    },[]);

    // VALIDAR QUE LOS DATOS ESTÉN COMPLETOS
    useEffect(()=>{
        try{
            if(placa.length != 6 || entidad == "" || autorizacion == "" || descripcion == ""){
                throw new Error();
            }
            HandlerDatosCompletos(true);
        }catch(error){
            HandlerDatosCompletos(false);
        }
    },[placa, entidad, autorizacion, descripcion]);

    useEffect(()=>{
        codigoEntidad != "" && HandlerEntidad(NMEntidadEmisora(codigoEntidad));
    },[codigoEntidad])

    //#endregion

    // ======================================================================================================
    //#region  HOOK NAVIGATE
    // ======================================================================================================
    const navigate = useNavigate();
    const{codVehiculoActualizar} = useParams();
    //#endregion

    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================
    //ESTADOS DE REGISTRO
    //ESTADOS DE CONTENIDO
    const HandlerSelectEntidades = (lista) => {
        setSelectEntidades(<>{lista.map((item, index)=>(
            <option key={index} value={item.codigoCatalogo} >{item.descEntidad}</option>
        ))}</>)
    }
    
    const HandlerEntidad = (valor) => setEntidad(valor);
    
    const HandlerAutorizacion = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setAutorizacion(valor.toUpperCase());
        }
    }
    const HandlerPlaca = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setPlaca(valor.toUpperCase());
        }
    }
    const HandlerDescripcion = (valor) => {
        if(ValidarNumLtr(valor) || valor ==""){
            setDescripcion(valor.toUpperCase());
        }
    }
    const HandlerCodigoEntidad = (valor) => {
        setCodigoEntidad(valor);
    }
    //ESTADOS DE VALIDACIÓN
    const HandlerDatosCompletos = (valor) => setDatosCompletos(valor);
    //#endregion

    //#endregion

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    const obtenerListaEntidades = async () => {
        try{
            let response = await axios.get(URL_ENTIDADES_EMISORAS,{
                headers: HEADERS_API
            }).catch(error =>{
                throw new Error(error.message);
            });

            if(response.data.mensajeError != null){
                throw new Error(response.data.mensajeError);
            }

            HandlerSelectEntidades(response.data.lista);
        }catch(error){
            console.log(error.message);
        }
    }
    const obtenerDatosVehiculo = async () => {
        try{
            const response = await axios.get(URL_DATOS_VEHICULO, {
                headers: HEADERS_API,
                params: {
                    codigoConsultar: codVehiculoActualizar
                }
            }).catch(error => {
                throw new Error(error.message);
            });

            const datos = response.data;

            if(datos.placa == null){
                throw new Error("El vehiculo no existe");
            }

            HandlerPlaca(datos.placa);
            HandlerDescripcion(datos.descripcion);
            HandlerEntidad(datos.entidad);
            HandlerCodigoEntidad(datos.codigoEntidad);
            HandlerAutorizacion(datos.autorizacion);
        }catch(error){
            console.log(error);
            navigate('/vehiculos');
        }
    }
    const EditarVehiculo = async () => {
        try{
            let response = await axios.put(URL_EDITAR_VEHICULO, {
                placaVehiculoEditar: codVehiculoActualizar,
                placa: placa,
                entidad: entidad,
                autorizacion: autorizacion,
                descripcion: descripcion,
                codigoEntidad: codigoEntidad
            }, {
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.response.data);
            });

            navigate("/vehiculos");
        }catch(error){
            mostrarAviso(error, 2500);
        }
    }
    // FUNCIONES COMPLEMENTARIAS

    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <Aviso/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className='col-12 p-3 text-secondary'>
                <Link className='' to={'/vehiculos'}>
                    <button className='btn btn-secondary'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-return-left" 
                        viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5"/>
                        </svg>
                        <span className='mx-2'>Regresar</span>
                    </button>
                </Link>
            </div> 
            <div className='col-12 pb-2 fs-3 fw-semibold'>
                DETALLE DE VEHICULO
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label htmlFor="placa-vehiculo" className="col-form-label fw-semibold">Placa</label>
                    <input onChange={e=>HandlerPlaca(e.target.value)} value={placa} maxLength={10} type="text" className="form-control text-uppercase" id="placa-vehiculo"/>
                    <small className="text-danger">Incluir solo los números y letras de la placa</small>
                </div>
                <div className="p-1">
                    <label htmlFor="descripcion-vehiculo" className="col-form-label fw-semibold">Descripción del vehículo</label>
                    <input onChange={e=>HandlerDescripcion(e.target.value)} value={descripcion} maxLength={150} type="text" className="form-control text-uppercase" id="descripcion-vehiculo" autoComplete="off"/>
                </div>
            </div>
            <div className="col-12 col-md-6">
                <div className="p-1">
                    <label htmlFor="entidad-vehiculo" className="col-form-label fw-semibold">Entidad Emisora</label>
                    <select value={codigoEntidad} onChange={e => HandlerCodigoEntidad(e.target.value)} id="entidad-vehiculo" type="select" className="form-select f-actor-texto" >
                        {selectEntidades}                          
                    </select>
                </div>
                <div className="p-1">
                    <label htmlFor="autorizacion-vehiculo" className="col-form-label fw-semibold">N° Autorización Especial</label>
                    <input onChange={e=>HandlerAutorizacion(e.target.value)} value={autorizacion} maxLength={15} type="text" className="form-control" id="autorizacion-vehiculo" autoComplete="off"/>
                </div>
            </div>
            <div className="col-12 py-3 d-flex justify-content-center align-items-center">
                <button onClick={EditarVehiculo} disabled={!datosCompletos} className="btn btn-primary">Guardar Cambios</button>
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_ENTIDADES_EMISORAS = process.env.REACT_APP_URL_ENTIDADES_EMISORAS;
const URL_DATOS_VEHICULO = process.env.REACT_APP_URL_DATOS_VEHICULO;
const URL_EDITAR_VEHICULO = process.env.REACT_APP_URL_EDITAR_VEHICULO;
//#endregion